import Button from "components/Button/Button";
import Card from "components/Card/Card";
import KaboodleModal from "components/Modals/KaboodleModal";

type DisputeAllModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onDecline: () => void;
};

const DisputeAllModal = ({
  isOpen,
  onClose,
  onConfirm,
  onDecline,
}: DisputeAllModalProps) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleDecline = () => {
    onDecline();
    onClose();
  };

  return (
    <KaboodleModal
      isOpen={isOpen}
      onClose={onClose}
      footer={
        <div className="flex jc-c">
          <Button onClick={handleConfirm}>Dispute All</Button>
          <Button onClick={handleDecline}>No, Just This One</Button>
        </div>
      }
    >
      <Card heading="Dispute All Matching Codes?">
        <p>
          This ICD code appears in other payment histories. Would you like to
          dispute all matching codes at this level of appeal?
        </p>
      </Card>
    </KaboodleModal>
  );
};

export default DisputeAllModal;
